import React, { useEffect } from 'react'
import injectSheet from 'react-jss'
import styles from './shared.styles'
import SharedTable from './shared-table/shared-table.container'
import SharedSkeleton from './shared-skeleton/shared-skeleton'
import WarningMessage from '../../../../warning-message/warning-message'

const Shared = ({ onMount, noPresentations, pending }) => {
  useEffect(() => {
    onMount()
  }, []) // eslint-disable-line

  return noPresentations ? (
    <WarningMessage>You don't have lessons shared with you yet</WarningMessage>
  ) : pending ? (
    <SharedSkeleton />
  ) : (
    <SharedTable />
  )
}

export default injectSheet(styles)(Shared)
